export const KPI_VALUE_WIDTH = 300;
export const KPI_VALUE_FLEX = "0 0 25%";
